import { colors } from 'styles/colors';
import { columnWidth } from 'components/landing/Hindisvik/styles';
import styled from 'styled-components';

export const Wrapper = styled.div`
  padding-top: 3rem;
`;

export const Box = styled.aside`
  max-width: ${columnWidth};
  margin: 0 auto;
  padding: 1.25rem 1.5rem;
  border-left: 4px solid ${colors.roof};
  border-radius: 0 0.5rem 0.5rem 0;
  background: ${colors.sand};
  color: ${colors.ink};
  font-size: 1.05rem;
  line-height: 1.6;

  p {
    margin-bottom: 0.75rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  a {
    color: ${colors.sea};
    text-decoration: underline;
  }
`;
